export class AuthConfig {
  apiEndpoint!: string;
  userPoolId!: string;
  identityPoolId!: string;
  clientId!: string;
  region!: string;
  oauthDomain!: string;
  localMock!: boolean;
}
